import React, { useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled';
import CompanyLogo from '../../components/CompanyLogo/CompanyLogo';
import { LoadingAltLoop } from '../../components/Icons/LoadingAltLoop';
import { InternalNavLink } from '../../components/Link/Link';
import { ACCOUNT, SIGNIN } from '../../routes/routeConstants';
import { useSearchParams } from 'react-router';
import useUnsubscribe from '../../hooks/unsubscribe/useUnsubscribe';
import Img from '../../components/Img/Img';

const Unsubscribe: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? undefined;

  const { loading, failed, tryAgain } = useUnsubscribe(token);

  const [holdForSplash, setHoldForSplash] = useState(true);
  const splashStartedRef = useRef(false);

  useEffect(() => {
    if (splashStartedRef.current) return;
    splashStartedRef.current = true;

    const t = setTimeout(() => setHoldForSplash(false), 2000);
    return () => clearTimeout(t);
  }, []);

  console.log(token);

  const showLoading = loading || holdForSplash;

  return (
    <Container>
      <CompanyLogo />

      {showLoading && (
        <Loading>
          <LoadingAltLoop />
          <p>Working...</p>
        </Loading>
      )}

      {!showLoading && !failed && token && (
        <Success>
          <Img src="/static/img/success.png" />
          <p>
            You have successfully unsubscribed, you won't receive our emails
            anymore.
          </p>
          <br />
          <P>
            Go to{' '}
            <InternalNavLink to={`/${ACCOUNT}/${SIGNIN}`} className="regular">
              Sign In
            </InternalNavLink>
          </P>
        </Success>
      )}

      {!showLoading && (!token || failed) && (
        <Failed>
          {/* <Img src="/static/img/failed.png" /> */}
          <p>{!token ? 'Invalid link' : 'Failed!'}</p>
          <br />
          <p onClick={tryAgain}>Try Again</p>
          <p>or</p>
          <P>
            Go to{' '}
            <InternalNavLink to={`/${ACCOUNT}/${SIGNIN}`} className="regular">
              Sign In
            </InternalNavLink>
          </P>
        </Failed>
      )}
    </Container>
  );
};

export default Unsubscribe;

const Container = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  overflow: scroll;
  overflow-x: hidden;
  padding-top: 3.75rem;
  padding-bottom: 3.4rem;
  padding: 1rem;
`;

const Loading = styled.div`
  color: ${({ theme }) => theme.palette.greyGrey3};
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
`;

const Success = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  gap: 3rem;
  text-align: center;
`;

const Failed = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  text-align: center;

  & p:nth-of-type(1) {
    color: ${({ theme }) => theme.palette.stateColorRed};
  }

  & p:nth-of-type(2) {
    color: ${({ theme }) => theme.palette.stateColorRed};
    font-size: 20px;
    cursor: pointer;
    font-weight: 500;
  }
`;

const P = styled.span`
  display: flex;
  gap: 4px;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme }) => theme.palette.blackBlack2};
  font-weight: 400;

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;
